// Author : Ayesha Shaikh
// Date : 18-08-2025

import { Collapse, Grid, MenuItem, Select, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import MainCard from "../../../../../components/Maincard";
import CustomTextFieldComp from "../../../../newComponent/customTextFieldComp";
import SearchButton from "../../../../newComponent/NewButtonComp/SearchButton";
import CustomNoRowsOverlay from "../../../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { DataGrid } from "@mui/x-data-grid";
import CustomAutocompleteComp from "../../../../newComponent/AutocompleteComp";
import { useGetTokenOrLogout } from "../../../../../utils/token";
import CustomSnackbar from "../../../../components/ui-component/snackbar/CustomSnackbar";
import LoaderComp from "../../../../newComponent/LoaderComp/Loader";
import SearchTextFieldComp from "../../../../newComponent/newtextfieldComp/SearchTextFieldComp";
import CustomPopup from "../../../../../components/CustomPopup";
import CampaignWiseDetailsReport from "./CampaignWiseDetailsReport";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function CampaignWiseReport({ open }) {
  const getTokenOrLogout = useGetTokenOrLogout();
  const userId = localStorage.getItem("userId");
  const [facebookCampaignList, setFacebookCampaignList] = useState([]);
  const [facebookCampaign, setFacebookCampaign] = useState([]);
  const [filterType, setFilterType] = useState("today");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setTodate] = useState(null);
  const [campainwiseData, setCampaignWiseData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [facebookCampaignLoading, setFaceBookCampaignLoading] = useState(false);
  const [detailesLoading, setDetailsLoading] = useState(false);
  const [detailsData, setDetailsData] = useState([]);
  const [rowData, setRowData] = useState({});
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        setFaceBookCampaignLoading(true);
        const response = await fetch(`${API_ENDPOINT}facebook-campaign`);
        const data = await response.json();
        if (response.ok) {
          setFacebookCampaignList(data);
        } else if (response.status === 400) {
          console.error("Error fetching data:");
          setFaceBookCampaignLoading(true);
        } else {
          console.error("Error fetching data:");
          setFaceBookCampaignLoading(true);
        }
      } catch (error) {
        console.error("Error fetching data:");
        setFaceBookCampaignLoading(true);
      }
    };

    fetchData();
  }, []);

  const allFacebookCampaignList =
    facebookCampaignList.length > 0
      ? [{ name: "Select All" }, ...facebookCampaignList]
      : [];

  const handleChangeFaceBookCampaign = (e, value) => {
    if (value.some((option) => option.name === "Select All")) {
      setFacebookCampaign(facebookCampaignList);
    } else {
      setFacebookCampaign(value);
    }
  };

  const handleFilterChange = (event) => {
    setFromDate(null)
    setTodate(null)
    setFilterType(event.target.value);
  };

  const columns = [
    {
      field: "campaign_name",
      headerName: "Facebook Campaign",
      flex: 1,
       minWidth: 250,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.row?.campaign_name || "",
      renderCell: (params) => {
      const isLastRow = params?.row?.campaign_name === "Total";
        return (
          <div
            style={{
              color: isLastRow ? "black" : "",
              fontSize: isLastRow ? "0.8rem" : "",
              fontWeight: isLastRow ? 700 : 500,
            }}
          >
            {params.row?.campaign_name}
          </div>
        );
      },
    },
    {
      field: "form_name",
      headerName: "Form Name",
      flex: 1,
      minWidth: 250,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.row?.form_name || "",
      renderCell: (params) => {
        const isLastRow = params?.row?.campaign_name === "Total";

        return (
          <div
            style={{
              color: isLastRow ? "black" : "",
              fontSize: isLastRow ? "0.8rem" : "",
              fontWeight: isLastRow ? 700 : 500,
            }}
          >
            {params.row?.form_name}
          </div>
        );
      },
    },
    {
      field: "stm_campaign_name",
      headerName: "Associated stm Campaign",
      flex: 1,
        minWidth: 250,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) => params.row?.stm_campaign?.campaign_name || "",

      renderCell: (params) => {
        const isLastRow = params?.row?.campaign_name === "Total";
        return (
          <div
            style={{
              color: isLastRow ? "black" : "",
              fontSize: isLastRow ? "0.8rem" : "",
              fontWeight: isLastRow ? 700 : 500,
            }}
          >
            {params.row?.stm_campaign?.campaign_name}
          </div>
        );
      },
    },
    {
      field: "meta_enq",
      headerName: "Total Enquiry",
      flex: 1,
        minWidth: 100,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const isLastRow = params?.row?.campaign_name === "Total";
        return (
          <div
            style={{
              color: isLastRow ? "black" : "blue",
              cursor: !isLastRow ? "pointer" : null,
              fontSize: isLastRow ? "0.8rem" : "",
              fontWeight: isLastRow ? 700 : 500,
            }}
          onClick={() => !isLastRow ? handleSearchDetailsData(params?.row) :undefined}
          >
            {params.row?.meta_lead}
          </div>
        );
      },
    },
  ];

  const handleSearchData = async (event) => {
    setLoading(true);

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      user_id: parseInt(userId),
      facebook_campaign_id: facebookCampaign?.map((i) => i.id),
      filter: filterType,
      meta_from_date: fromDate || null,
      meta_to_date: toDate || null,
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}route2.0/meta-campaignwise-report`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      const result = await response.json();
      if (response.ok) {
        setCampaignWiseData(result);
        setSearchData(result);
        setLoading(false);
      } else if ([400, 401, 403, 500].includes(response.status)) {
        showSnackbar(result.message, "error");
        setCampaignWiseData([]);
        setSearchData([]);
        setLoading(false);
      } else {
        showSnackbar("Internal server error", "error");
        setLoading(false);
        setCampaignWiseData([]);
        setSearchData([]);
      }
    } catch {
      showSnackbar("Internal server error", "error");
      setLoading(false);
      setCampaignWiseData([]);
      setSearchData([]);
    }
  };

  useEffect(() => {
    handleSearchData();
  }, []);

  const handleSearchByName = (e) => {
    const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)

    let filteredData1 = searchData.filter((data) => {
      // Check each field for a match with the search value
      const fieldsToSearch = [
        `${data?.campaign_name || ""}`,
        `${data?.form_name || ""}`,
        `${data?.stm_campaign?.campaign_name || ""}`,
        `${data?.meta_lead || ""}`,
      ];
      // Check if any of the fields contain the search value
      return fieldsToSearch.some((field) =>
        field.toLowerCase().replace(/\s+/g, "").includes(value)
      );
    });

    setCampaignWiseData(filteredData1); // Update the filtered data
  };

  // Details Data
  const handleOpenPopup = (rowData) => {
    setDetailsOpen(true);
    setRowData(rowData);
  };
  const handleClosePopup = () => {
    setDetailsOpen(false);
  };

  const handleSearchDetailsData = async (rowData) => {
    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      facebook_campaign_name: rowData?.campaign_name,
      filter: filterType,
      user_id: parseInt(userId),
      meta_from_date: fromDate || null,
      meta_to_date: toDate || null,
    };

    try {
      setDetailsLoading(true)
      const response = await fetch(
        `${API_ENDPOINT}route2.0/meta-campaignwise-report-with-detail`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      const result = await response.json();
      if (response.ok) {
        setDetailsLoading(false);

        setDetailsData(result);
        setSearchData(result);
        handleOpenPopup(rowData);
      } else if ([400, 401, 403, 500].includes(response.status)) {
        showSnackbar(result.message, "error");
            setDetailsLoading(false);
      } else {
        showSnackbar("Server Error", "error");
        setDetailsLoading(false);
      }
    } catch {
      showSnackbar("Server Error", "error");
      setDetailsLoading(false);
    }
  };
  return (
    <>
      <LoaderComp isLoading={loading || detailesLoading} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Collapse in={open}>
            <MainCard>
              <Grid container spacing={2}>
                {/* facebook campaign list dropdown */}
                <Grid item xs={12} lg={3} md={4} sm={6}>
                  <Typography variant="h6">Facebook Campaign</Typography>
                  <CustomAutocompleteComp
                    multiple
                    limitTags={1}
                    value={facebookCampaign}
                    options={allFacebookCampaignList}
                    noOptionsText={
                      facebookCampaignLoading &&
                      facebookCampaignList.length === 0
                        ? "Loading...."
                        : ""
                    }
                    onChange={handleChangeFaceBookCampaign}
                    getOptionLabel={(option) => option.name}
                    tooltipContent={(option) => option.name}
                  />
                </Grid>

                <Grid item xs={12} lg={2} md={4} sm={6}>
                  <Typography variant="h6">
                    Enquiry Created Date Filter
                  </Typography>
                  <Select
                    value={filterType}
                    onChange={handleFilterChange}
                    fullWidth
                    style={{ borderRadius: "10px" }}
                    size="medium"
                  >
                    <MenuItem value="today">Today</MenuItem>
                    <MenuItem value="currentweek">This Week</MenuItem>
                    <MenuItem value="currentmonth">This Month</MenuItem>
                    <MenuItem value="custom">Custom</MenuItem>
                  </Select>
                </Grid>

                {filterType === "custom" && (
                  <>
                    <Grid item xs={12} lg={2} md={4} sm={6}>
                      <Typography variant="h6">
                        {" "}
                        Enquiry Created From Date
                      </Typography>
                      <CustomTextFieldComp
                        size="normal"
                        fullWidth
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        InputProps={{
                          style: { borderRadius: "10px" },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} lg={2} md={4} sm={6}>
                      <Typography variant="h6">
                        {" "}
                        Enquiry Created To Date
                      </Typography>
                      <CustomTextFieldComp
                        size="normal"
                        fullWidth
                        type="date"
                        value={toDate}
                        onChange={(e) => setTodate(e.target.value)}
                        InputProps={{
                          style: { borderRadius: "10px" },
                        }}
                      />
                    </Grid>
                  </>
                )}

                <Grid item xs={12} lg={2}>
                  <Typography sx={{ visibility: "hidden" }}>Hidden </Typography>
                  <SearchButton showIcon={true} onClick={handleSearchData} />
                </Grid>
              </Grid>
            </MainCard>
          </Collapse>
        </Grid>

        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                container
                justifyContent="end"
                alignItems="center"
                gap={1}
              >
                <SearchTextFieldComp onChange={handleSearchByName} />
              </Grid>
              <Grid item xs={12}>
                <DataGrid
                  rows={campainwiseData}
                  columns={columns}
                  autoHeight
                  slots={{
                    noRowsOverlay: CustomNoRowsOverlay,
                  }}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 25,
                      },
                    },
                  }}
                  pageSizeOptions={[25, 50, 100]}
                />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />


        <CustomPopup
                    open={detailsOpen}
                    onClose={handleClosePopup}
                    component={
                      <CampaignWiseDetailsReport
                        detailsData={detailsData}
                        rowData={rowData}
                        filterType={filterType}
                        fromDate={fromDate}
                        toDate={toDate}
                     
                      />
                    }
                    title="Meta Enquiry Details"
                    maxWidth="lg"
                    showDivider={true}
                  />
    </>
  );
}
